import i18n from 'i18next';
import { registerValidator } from 'core/forms';
import { isValid, parseISO } from 'date-fns';

const isISODateFormatted = ({ fieldValue }) => ({
  error: i18n.t('error-not-iso-date-format'),
  hasError: fieldValue?.length > 0 && (!fieldValue.match(/^\d{4}-\d{2}-\d{2}$/) || !isValid(parseISO(fieldValue))),
});

registerValidator('isISODateFormatted', isISODateFormatted);

export default isISODateFormatted;
